var _circle, _g, _circle2, _circle3, _g2, _circle4, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBuy3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#13AE67",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4551_75628)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 25,
    height: 40,
    rx: 4,
    fill: "white",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.8333,
    y: 16.8333,
    width: 23.3333,
    height: 38.3333,
    rx: 3.16667,
    stroke: "url(#paint0_linear_4551_75628)",
    strokeWidth: 1.66667
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 21.5,
    r: 1.5,
    fill: "#D7D7D7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 41,
    r: 10,
    fill: "#F1D905"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4551_75628)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4551_75628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 35.4443C20.6246 35.4443 17.8887 37.5847 17.8887 40.225C17.8887 41.9436 19.048 43.4496 20.7877 44.2923C20.6598 44.7647 20.3248 46.0031 20.2577 46.2682C20.1751 46.5971 20.3796 46.5927 20.5135 46.5041C20.6186 46.4348 22.1883 45.3791 22.8654 44.9233C23.233 44.9771 23.612 45.0056 23.9998 45.0056C27.3749 45.0056 30.1109 42.865 30.1109 40.225C30.1109 37.585 27.3749 35.4443 23.9998 35.4443Z",
    fill: "#341B1D"
  })))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 41,
    r: 10,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4551_75628)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1331 41.1221C53.1331 40.7426 53.0988 40.3788 53.0362 40.0283H47.9995V42.0967H50.8769C50.7531 42.7648 50.3758 43.3314 49.8099 43.7102V45.0516H51.5382C52.5493 44.121 53.1324 42.7498 53.1324 41.1214L53.1331 41.1221Z",
    fill: "#4377BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9996 46.3481C49.4431 46.3481 50.654 45.8695 51.5383 45.053L49.81 43.7116C49.3313 44.0322 48.7184 44.2224 47.9996 44.2224C46.6068 44.2224 45.428 43.2814 45.0074 42.0176H43.2217V43.4029C44.1015 45.1507 45.9096 46.3489 48.0004 46.3489L47.9996 46.3481Z",
    fill: "#36A052"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0082 42.0166C44.9016 41.6959 44.8405 41.353 44.8405 41.0003C44.8405 40.6476 44.9009 40.3054 45.0082 39.984V38.5986H43.2217C42.8594 39.3211 42.6528 40.1376 42.6528 41.0003C42.6528 41.863 42.8594 42.6794 43.2217 43.4019L45.0082 42.0166Z",
    fill: "#EFB619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9996 37.7798C48.7848 37.7798 49.4894 38.0497 50.0434 38.5791L51.5771 37.0454C50.6518 36.1835 49.4409 35.6533 47.9996 35.6533C45.9096 35.6533 44.1015 36.8515 43.2217 38.5993L45.0082 39.9846C45.4287 38.7208 46.6075 37.7798 48.0004 37.7798H47.9996Z",
    fill: "#DA4234"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4551_75628",
    x: 20.6667,
    y: 12.6667,
    width: 31.6667,
    height: 46.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4551_75628"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4551_75628",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4551_75628",
    x1: 25.6728,
    y1: 16,
    x2: 57.3007,
    y2: 24.2754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4551_75628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(17.3335 34.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4551_75628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.2222,
    height: 11.1111,
    fill: "white",
    transform: "translate(17.8887 35.4443)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4551_75628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.4805,
    height: 10.6944,
    fill: "white",
    transform: "translate(42.6528 35.6533)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuy3);
export default __webpack_public_path__ + "static/media/ic-buy3.0bb2b1abf6f40ef496e28dc2b5de6658.svg";
export { ForwardRef as ReactComponent };